import Axios from 'axios'
import getDomainURL from './getDomainURL'

export const Get = ( url, response, error, load ) => {
  load( true )
  Axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-key': process.env.REACT_APP_API_KEY
  }
  return Axios.get( `${ getDomainURL() }${ url }` ).then( res => {
    response( res.data )
    load( false )
  }).catch( err => {
    if( err && err.response && err.response.status ) {
      if( err.response.status === 401 ) {
        if( err.response.data.internal_code === 460 ) {
          // OutdatedToken( () => load( true ), () => Get( url, response, error, load ) )
          error( err.response.data.message )
        }
      } else {
        error( err.response.data.message )
      }
    } else if( err && err.message ) {
      error( err.message )
    } else {
      error( 'You are disconnnected from the internet, please reconnect to use Atlas. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}

export const Post = ( url, data, response, error, load, config ) => {
  load( true )
  Axios.defaults.headers = {
    'Access-Control-Allow-Origin' : '*',
    'x-api-key': process.env.REACT_APP_API_KEY
  }
  return Axios.post( `${ getDomainURL() }${ url }`, data, config ).then( res => {
    response( res.data )
    load( false )
  }).catch( async( err ) => {
    if( err && err.response && err.response.status ) {
      if( err.response.status === 401 ) {
        if( err.response.data.internal_code === 460 ) {
          // OutdatedToken( () => load( true ), () => Post( url, data, response, error, load ) )
        }
      } else {
        if ( err.response.request.responseType === "blob" ) {
          const blob = await new Blob([ err.response.data ], { type : 'application/json' });
          const text = await blob.text()
          error( JSON.parse( text ).message )
        } else
          error( err.response.data.message )
      }
    } else if( err && err.message ) {
      error( err.message )
    } else {
      error( 'You are disconnnected from the internet, please reconnect to use Atlas. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}

export const Put = ( url, data, response, error, load ) => {
  load( true )
  // let token = getItem( 'IQI_ATLAS_JWT_TOKEN' )
  Axios.defaults.headers = {
    'Access-Control-Allow-Origin' : '*',
    'x-api-key': process.env.REACT_APP_API_KEY
  }
  return Axios.put( `${ getDomainURL() }${ url }`, data ).then( res => {
    response( res.data )
    load( false )
  }).catch( err => {
    if( err && err.response && err.response.status ) {
      if( err.response.status === 401 ) {
        if( err.response.data.internal_code === 460 ) {
          // OutdatedToken( () => load( true ), () => Put( url, data, response, error, load ) )
        }
      } else {
        error( err.response.data.message )
      }
    } else if( err ) {
      error( err.message )
    } else {
      error( 'You are disconnnected from the internet, please reconnect to use Atlas. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}